import { render, staticRenderFns } from "./backend-performance.vue?vue&type=template&id=d1fe23ea&scoped=true"
import script from "./backend-performance.vue?vue&type=script&lang=js"
export * from "./backend-performance.vue?vue&type=script&lang=js"
import style0 from "./backend-performance.vue?vue&type=style&index=0&id=d1fe23ea&prod&scoped=true&lang=css"
import style1 from "./backend-performance.vue?vue&type=style&index=1&id=d1fe23ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fe23ea",
  null
  
)

export default component.exports